export const

    sensor = {
        no2: "NO2",
        no: "NO",
        o3: "O3",
        co2: "CO2",
        co: "CO",
        so2: "SO2",
        h2s: "H2S",
        nh3: "NH3",
        pm1: "PM1",
        pm2p5: "PM2P5",
        pm4: "PM4",
        pm10: "PM10",
        pm40: "PM40",
        voc_iaq: "VOC_IAQ",
        noise: "noise",
        temperature: "temperature",
        rh: "relativeHumidity",
        ah: "absoluteHumidity",
        temperature_meteo: "temperatureMeteo",
        rh_meteo: "relativeHumidityMeteo",
        pressure: "pressure",
        equivalent_pressure: "equivalentPressure",
        rain_rate: "rainRate",
        solar_radiation: "solarRadiation",
        uv_index: "uvIndex",
        wind: "wind",
        wind_speed: "windSpeed",
        wind_gust: "windGust",
        wind_direction: "wdirection",
        battery: "battery",
        voc: "VOC",
        pvoc: "pVOC",
        aqi: "aqi",
    },

    indexTypes = {
        AQI: 'AQI',
        EAQI: 'EAQI',
        ICQA: 'ICQA',
        DIBA: 'DIBA',
        ISPU: 'ISPU',
        AQHI: 'AQHI',
        APIMS: 'APIMS',
        ICA: 'ICA',
        "AQI-QB": 'AQI-QB',
        DAQI: 'DAQI',
        "AQI-CH": 'AQI-CH',
        IQAR: 'IQAR',
        "AQHI-MX": 'AQHI-MX'
    },

    indexMoreInfoUrl = {
        "AQHI-MX": "https://dof.gob.mx/nota_detalle.php?codigo=5715154&fecha=25/01/2024#gsc.tab=0",
        AQI: "https://www.airnow.gov/aqi/aqi-basics/",
        EAQI: "https://airindex.eea.europa.eu/AQI/index.html",
        ISPU: "https://ditppu.menlhk.go.id/portal/read/indeks-standar-pencemar-udara-ispu-sebagai-informasi-mutu-udara-ambien-di-indonesia",
        ICQA: "https://mediambient.gencat.cat/ca/05_ambits_dactuacio/atmosfera/qualitat_de_laire/avaluacio/icqa/index.html",
        DIBA: "https://www.diba.cat/mediambient",
        AQHI:"https://www.canada.ca/en/environment-climate-change/services/air-quality-health-index.html",
        APIMS:"https://apims.doe.gov.my/home.html",
        ICA: "https://www.minambiente.gov.co/wp-content/uploads/2021/10/Resolucion-2254-de-2017.pdf",
        "AQI-QB": "https://www.iqa.environnement.gouv.qc.ca/contenu/calcul_en.htm",
        DAQI: "https://uk-air.defra.gov.uk/air-pollution/daqi?view=more-info",
        IQAR:"https://www.gov.br/mma/pt-br/acesso-a-informacao/acoes-e-programas/programa-projetos-acoes-obras-atividades/agendaambientalurbana/ar-puro/GuiaTecnicoparaQualidadedoAr.pdf"
    },

    stationState = {
        active: "active",
        online: "online",
        offline: "offline"
    },

    MODEL_EXTERNAL_PREFIX = "EXT-",

    TEXT_COLOR          = "#484848",
    TEXT_COLOR_CONTRAST = "#FFFFFF",

    AQI_RANGE = ["currentMonth", "lastMonth", "last3Month"];

